import { Button, Modal, Form, Row, Col, Select, Input, message } from "antd";
import { useEffect, useState } from "react";
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { handleFetchUnits } from "../../../../api/units";
import { handleUpdateBusiness } from "../../../../api/businesses";
import getBase64 from "../../../../utils/getBase64";
import { BsCheck2Circle } from "react-icons/bs";

const { Option } = Select;

export default function UpdateBusiness({ isVisible, setVisible, selected }: any) {
  const queryClient = useQueryClient();
  const [form] = Form.useForm();
  const [isSelected, setIsSelected] = useState(false);
  const [selectedFile, setSelectedFile]: any = useState(null);

  const changeHandler = (event: any) => {
    setSelectedFile(event.target.files[0]);
    setIsSelected(true);
  };


  const { mutate, isPending } = useMutation({
    mutationFn: handleUpdateBusiness,
    onSuccess: () => {
      message.success("Updated Successfully");
      form.resetFields();
      setVisible(false);
      queryClient.invalidateQueries({ queryKey: ["users"] });
    },
    onError: () => {
      message.error("Something went wrong");
    },
  });


  const onSubmit = async () => {
    const { ...rest } = await form.getFieldsValue();

    let base64,
      type,
      size = null;

    if (selectedFile) {
      base64 = await getBase64(selectedFile);
      type = selectedFile?.type?.slice(selectedFile?.type - 3);
      size = selectedFile?.size;
    }

    const data = {
      ...rest,
      logo: base64,
    };

    await mutate({_id: selected?._id, data});
  };

  const clearForm = async () => {
    form.resetFields();
  };


  useEffect(() => {
    form.resetFields();
    form.setFieldsValue({ name: selected?.name });
    form.setFieldsValue({ companyMo: selected?.companyMo });
    form.setFieldsValue({ addressLine1: selected?.addressLine1 });
    form.setFieldsValue({ addressLine2: selected?.addressLine2 });
    form.setFieldsValue({ addressLine3: selected?.addressLine3 });
    form.setFieldsValue({ addressLine4: selected?.addressLine4 });
    form.setFieldsValue({ addressLine5: selected?.addressLine5 });
  }, [selected]);

  return (
    <Modal
      open={isVisible}
      title="Update Business"
      onCancel={() => setVisible(false)}
      footer={[
        <Button danger key="back" onClick={clearForm}>
          Clear
        </Button>,
        <Button
          key="submit"
          form="updateBusiness"
          htmlType="submit"
          type="primary"
          onSubmit={onSubmit}
          loading={isPending}
          danger
        >
          Update
        </Button>,
      ]}
    >
      <Form
        id="updateBusiness"
        form={form}
        name="normal_login"
        className="login-form"
        onFinish={onSubmit}
        layout="vertical"
      >
        <Row gutter={[16, 0]}>
          <Col xs={{ span: 24 }} lg={{ span: 12 }}>
            <Form.Item
              name="name"
              label="Name"
              rules={[
                {
                  required: true,
                  message: "Please enter name",
                },
              ]}
            >
              <Input type="text" placeholder="Name" />
            </Form.Item>
          </Col>
          <Col xs={{ span: 24 }} lg={{ span: 12 }}>
            <Form.Item
              name="companyNo"
              label="Company Number"
              rules={[
                {
                  required: true,
                  message: "Please enter company No",
                },
              ]}
            >
              <Input type="text" placeholder="Company Number" />
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={[16, 0]}>
          <Col xs={{ span: 24 }} lg={{ span: 12 }}>
            <Form.Item
              name="addressLine1"
              label="Address Line 1"
              rules={[
                {
                  required: false,
                  message: "Please enter address line 1",
                },
              ]}
            >
              <Input type="text" placeholder="Address Line 1" />
            </Form.Item>
          </Col>
          <Col xs={{ span: 24 }} lg={{ span: 12 }}>
            <Form.Item
              name="addressLine2"
              label="Address Line 2"
              rules={[
                {
                  required: false,
                  message: "Please enter address line 2",
                },
              ]}
            >
              <Input type="text" placeholder="Address Line 2" />
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={[16, 0]}>
          <Col xs={{ span: 24 }} lg={{ span: 12 }}>
            <Form.Item
              name="addressLine3"
              label="Address Line 3"
              rules={[
                {
                  required: false,
                  message: "Please enter address line 3",
                },
              ]}
            >
              <Input type="text" placeholder="Address Line 3" />
            </Form.Item>
          </Col>
          <Col xs={{ span: 24 }} lg={{ span: 12 }}>
            <Form.Item
              name="addressLine4"
              label="Address Line 4"
              rules={[
                {
                  required: false,
                  message: "Please enter address line 4",
                },
              ]}
            >
              <Input type="text" placeholder="Address Line 4" />
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={[16, 0]}>
          <Col xs={{ span: 24 }} lg={{ span: 12 }}>
            <Form.Item
              name="addressLine5"
              label="Address Line 5"
              rules={[
                {
                  required: false,
                  message: "Please enter address line 5",
                },
              ]}
            >
              <Input type="text" placeholder="Address Line 5" />
            </Form.Item>
          </Col>
        </Row>
        <div className="flex flex-col justify-center items-center bg-gray-100 h-32 rounded-md border">
          <div className="flex flex-col justify-center items-center">
            {isSelected ? (
              <div className="flex flex-col justify-center items-center">
                <BsCheck2Circle color={"#16a34a"} size={30} />
                <div className="text-gray-600 mt-2">Image Selected</div>
                <div className="text-gray-500">{selectedFile?.name}</div>
              </div>
            ) : (
              <Form.Item
                name="file"
                label="Upload Logo ( Optional )"
                rules={[
                  {
                    required: false,
                    message: "Please select file",
                  },
                ]}
              >
                <Input
                  type="file"
                  placeholder="Logo"
                  onChange={changeHandler}
                />
              </Form.Item>
            )}
          </div>
        </div>
      </Form>
    </Modal>
  );
}
